import { render, staticRenderFns } from "./ForgotSent.vue?vue&type=template&id=80599d22&scoped=true"
import script from "./ForgotSent.vue?vue&type=script&lang=js"
export * from "./ForgotSent.vue?vue&type=script&lang=js"
import style0 from "./ForgotSent.vue?vue&type=style&index=0&id=80599d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80599d22",
  null
  
)

export default component.exports